import { useState } from "react";
import { C } from "../data/constants";
import { useApi } from "../hooks/useApi";
import { scrollTo } from "../hooks/useScrollFade";

const TIER_STYLES = {
  Bronze: { color: "#C97A00", bgClass: "tier-bronze" },
  Silver: { color: "#546E7A", bgClass: "tier-silver" },
  Gold:   { color: "#C2185B", bgClass: "tier-gold"   },
};

function TierCard({ tier, isOpen, onToggle }) {
  const { color, bgClass } = TIER_STYLES[tier.tier] || TIER_STYLES.Bronze;
  return (
    <div className={bgClass} onClick={onToggle}
      style={{ borderRadius: 18, overflow: "hidden", cursor: "pointer", transition: "transform 0.3s, box-shadow 0.3s" }}>
      <div style={{ padding: "22px 20px 16px", borderBottom: "1px solid rgba(0,0,0,0.07)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 7 }}>
          <span style={{ fontSize: 10, letterSpacing: 2, textTransform: "uppercase", color, fontWeight: 600 }}>{tier.tier}</span>
          <span style={{ fontSize: 10, background: `${color}22`, color, padding: "3px 9px", borderRadius: 10, fontWeight: 500 }}>{tier.highlight}</span>
        </div>
        <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: "clamp(18px,2.5vw,24px)", fontWeight: 600, color: C.dark, marginBottom: 4 }}>{tier.name}</h3>
        <p style={{ fontSize: "clamp(20px,2.5vw,26px)", fontWeight: 600, color, fontFamily: "'Cormorant Garamond',serif" }}>{tier.price}</p>
      </div>
      <div style={{ padding: "14px 20px 20px" }}>
        <p style={{ color, fontSize: 13, fontWeight: 500, marginBottom: isOpen ? 14 : 0 }}>
          {isOpen ? "▲ Hide details" : "▼ See what's included"}
        </p>
        {isOpen && (
          <ul style={{ listStyle: "none", padding: 0 }}>
            {tier.includes.map((item, j) => (
              <li key={j} style={{ display: "flex", alignItems: "flex-start", gap: 8, padding: "5px 0", borderBottom: "1px solid rgba(0,0,0,0.05)", fontSize: 13, color: C.mid }}>
                <span style={{ color, marginTop: 2, flexShrink: 0 }}>✓</span>{item}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default function Packages() {
  const { data, loading, error } = useApi("/packages");
  const packages = data?.data || {};
  const serviceKeys = Object.keys(packages);
  const [activeKey, setActiveKey] = useState(null);
  const [openTier, setOpenTier] = useState(null);
  const active = activeKey || serviceKeys[0];
  const pkg = packages[active];

  return (
    <section id="packages" className="section-pad" style={{ background: C.cream }}>
      <div className="container">
        <div className="section-header">
          <p style={{ color: C.blush, letterSpacing: 3, textTransform: "uppercase", fontSize: 11, marginBottom: 10 }}>Bronze · Silver · Gold</p>
          <h2 style={{ fontSize: "clamp(28px,4vw,48px)", fontWeight: 300, color: C.dark, marginBottom: 14 }}>Our Packages</h2>
          <div style={{ width: 48, height: 1, background: C.blush, margin: "0 auto 14px" }} />
          <p style={{ color: C.mid, maxWidth: 500, margin: "0 auto 28px", lineHeight: 1.8, fontSize: "clamp(13px,1.5vw,15px)" }}>
            Choose a service, then tap a tier to see what's included.
          </p>
        </div>

        {loading ? (
          <p style={{ textAlign: "center", color: C.slate, fontStyle: "italic", padding: "32px 0" }}>Loading packages…</p>
        ) : error ? (
          <p style={{ textAlign: "center", color: C.blush, padding: "32px 0", fontSize: 14 }}>
            Could not load packages — make sure the backend is running on port 5000.
          </p>
        ) : (
          <>
            {/* Service tabs — scrollable on mobile */}
            <div className="tabs-scroll" style={{ marginBottom: 20 }}>
              {serviceKeys.map(key => (
                <button key={key} className={`pkg-tab ${active === key ? "active" : "inactive"}`}
                  onClick={() => { setActiveKey(key); setOpenTier(null); }}>
                  {packages[key].icon} {key}
                </button>
              ))}
            </div>

            {pkg && <p style={{ textAlign: "center", color: C.mid, fontStyle: "italic", marginBottom: 24, fontSize: 14 }}>{pkg.desc}</p>}

            {pkg && (
              <div className="grid-auto-sm" style={{ marginBottom: 32 }}>
                {pkg.tiers.map((tier, i) => (
                  <TierCard key={i} tier={tier} isOpen={openTier === i} onToggle={() => setOpenTier(openTier === i ? null : i)} />
                ))}
              </div>
            )}

            <div style={{ textAlign: "center" }}>
              <p style={{ color: C.slate, fontSize: 13, marginBottom: 14, fontStyle: "italic" }}>
                All packages include setup, labour & transport within 20 km of Cape Town CBD.
              </p>
              <button onClick={() => scrollTo("contact")}
                style={{ background: C.blush, color: C.white, border: "none", padding: "12px 28px", borderRadius: 26, fontSize: 14, cursor: "pointer" }}>
                Book This Service 
              </button>
            </div>
          </>
        )}
      </div>
    </section>
  );
}